// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25d80104","316":"e41b8443"}[chunkId] + ".chunk.js";
};